import React from "react";
var __jsx = React.createElement;
import isNull from 'lodash/isNull';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import { useSelector } from 'react-redux';
import { getFirstLoadContent } from 'redux/content';

var MetaDateField = function MetaDateField(_ref) {
  var formField = _ref.formField;

  var _useSelector = useSelector(getFirstLoadContent),
      firstLoadContent = _useSelector.value;

  if (firstLoadContent === undefined) {
    return __jsx(React.Fragment, null);
  }

  var value = firstLoadContent[formField.metaDataField];
  return __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: formField.labelId
  }), " :", ' ', !isNull(value) && __jsx(React.Fragment, null, __jsx(FormattedDate, {
    value: value
  }), " ", __jsx(FormattedTime, {
    value: value
  })));
};

export default MetaDateField;